import React from 'react'

const Tooltip = ({
  text,
  isLast = false,
  textClassName,
}: {
  text: string
  isLast?: Boolean
  textClassName?: string
}) => {
  const [hovered, setHovered] = React.useState(false)
  return (
    <>
      <div
        className='tooltip-cover position-relative'
        onMouseEnter={(e) => {
          e.preventDefault()
          setHovered(true)
        }}
        onMouseLeave={(e) => {
          e.preventDefault()
          setHovered(false)
        }}
      >
        <i className='bi bi-info-circle ms-2 text-primary cursor-pointer position-relative'></i>

        <div
          className={`position-absolute bg-f4f4f4 card tooltip-card p-3 min-w-300px ${
            hovered ? 'd-block' : 'd-none'
          }`}
          style={
            isLast
              ? {bottom: '100%', left: '100%', border: '1px solid #000', zIndex: '99999'}
              : {top: '110%', border: '1px solid #000', zIndex: '99999'}
          }
        >
          <p className={`m-0 ${textClassName}`}>{text}</p>
        </div>
      </div>
    </>
  )
}
export default Tooltip
